module.exports = __webpack_public_path__ + "static/media/Imgur Album  Factorio  Smart Train Stations.1f287290.zip";